var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-select',{attrs:{"items":_vm.yearsOptions,"label":"År","dense":"","outlined":"","clearable":"","hide-details":""},model:{value:(_vm.year),callback:function ($$v) {_vm.year=$$v},expression:"year"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }